import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({

    /* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */
sidebar: {
    minWidth: "250px",
    maxWidth: "250px",
    background: "#354052",
    color: "#adb5bd",
    marginLeft: "-250px",
    transition: "all 0.5s",
    minHeight: "100vh",
  },
  
  isOpen: {
    marginleft: "0",
    transition: ".5s",
    minWidth: "250px",
    maxWidth: "250px",
    background: "#354052",
    color: "#adb5bd",
    minHeight: "100vh",
  },
  logoStyle: {
    width: "200px",
    margin: "-15px 0px -15px 25px"
},  
  
  sidebarHeader: {
    background: "#313b4c",
    color: "#adb5bd",
  },

  title : {
    color: "#fff",
    padding: "1em"  
  },

  closeButton: {
    position: "relative",
    float: "right",
    margin: ".5em",
    fontSize: "2rem",
    cursor: "pointer",
    //display: "none"
  },
  navItemsStyle: {
   // color: "#adb5bd !important",
    fontWeight: "300"
  },
  navLinkStyle: {
    display: "block",
    padding: "0.5rem 1.3rem",
    color: "#adb5bd",
    textDecoration: "none",
    transition: "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out",
    ":hover" : {
        background: "#313b4c",
        color: "#fff",
        transition: ".2s"
    }
  },

  
//   .collapse.show, 
//   .collapsing {
//     background: #313b4c;
//   }

  
//   .nav-item.open {
//     color: #e9ecef;
//     background: #313b4c;
//   }
  
//   .nav-item.active {
//     color: #e9ecef;
//     background: #2d3646 !important;
//   }
  
//   .nav-item:hover {
//     background: #313b4c;
//     color: #fff;
//     transition: .2s;
//   }
  
//   .nav-item .svg-inline--fa {
//     color: inherit;
//   }
  
//   li a.dropdown-toggle::after {
//     display: inline-flex;
//     position: relative;
//     left: 60%;
//     top: 10%
//   }
  
  
       
  });

  export default styles;